<template>
  <div>
    <Header></Header>
    <div class="headsmall">
      <div class="header_title contain_main">
        <!-- <div class="search">
          <span>选择考试:</span>
          <Select style="width:2rem">
            <Option>新员工入职考试</Option>
          </Select>
        </div>-->
        <div class="title">{{message.examtitle}}</div>
        <div class="message">
          <span>
            考试合格率：
            <Rate :rate="message.rate"></Rate>
            <span class="red">{{message.rate}}%</span>
          </span>
          <span>
            考试平均分：
            <span class="red">{{Number(message.score).toFixed(2)}}分</span>
            （总分{{Number(message.examscore).toFixed(2)}}分）
          </span>
          <span>
            考试平均用时：
            <span class="red">{{message.examtime}}</span>
          </span>
          <span>
              <div class="button" @click="$router.go(-1)">返回</div>
          </span>
           <span>
			             <!--  <router-link class="button routerlink" target="_blank" :to="{ path: '/api/ExamStatistics/export2?examid='+examid }">
			                 导出
			               </router-link> -->
              <div class="button" @click="exported">导出</div>
          </span>
        </div>
      </div>
    </div>
    <div class="contain_main main">
      <div class="issue"  v-for="(quest,index) in data" :key="'question'+index">
        <div class="issuetitle">{{quest.title}}</div>
        <div class="question" v-for="(item,index) in quest.questions" :key="'question'+index">
          <div class="questiontitle">
            <span>{{index+1}}. </span>
            <div v-html="item.question" class="quest"></div>
            <!-- <span class="score">（{{item.questionscore}}分）</span> -->
            <!-- <span>{{item.questiontype}}</span> -->
          </div>
          <div class="questiontable" v-if="item.statistics">
            <table>
              <tr>
                <td>选项</td>
                <td>数量</td>
                <td>占比</td>
              </tr>
              <tr v-for="(sitem,key) in item.statistics.data" :key="key">
                <td>
                  {{key}}
                  <!-- <span>（正确答案）</span> -->
                </td>
                <td>{{sitem.count}}</td>
                <td>
                  <Rate :rate="item.statistics.sum==0?0:(sitem.count*100/item.statistics.sum).toFixed(2)"/>
                  {{item.statistics.sum==0?0:(sitem.count*100/item.statistics.sum).toFixed(2)}}%
                </td>
              </tr>
              <tr style="background-color:#bbb">
                <td>合计</td>
                <td>{{item.statistics.sum}}</td>
                <td></td>
              </tr>
            </table>
          </div>
          <div class="questiondetail" v-if="!item.statistics" @click="showquestlist(item)">查看答案详情</div>
        </div>
      </div>
    </div>
    <toast v-if="show" :data='dataset' @close = "close" :examid='examid'></toast>
    <exportA  :dataUrl='dataUrl' @close = "close" v-if="isExport"></exportA>
  </div>
</template>
<script>
import Header from "../../components/header";
import Rate from "../../components/rate";
import toast from "../../components/toast/questlists";
import exportA from "../../components/toast/exportA";
import { ExamStatistics_report,ExamStatistics_export2 } from "../../assets/js/api.js";
export default {
  data() {
    return {
      data: [],
      show:false,
      dataset:{},
      isExport:false,
      examid:null,
      dataUrl:null,
      message: {
        examscore: 22,
        examtime: "703",
        examtitle: "",
        pass: "1",
        score: "5.681818",
        total: 44
      }
    };
  },
  components: {
    Header,
    Rate,
    toast,
    exportA 
  },
  mounted() {
    this.examid = this.$route.query.id
    this.getdata();
	// '/api/ExamStatistics/export2'
  },
  methods: {
    getdata() {
      ExamStatistics_report({ id: this.$route.query.id }).then(res => {
        if (res.data.code == 200) {
          if(res.data.data.epquestions[0].title){
            var list = res.data.data.epquestions
          }else{
            var list = [{title:"试题",questions:res.data.data.epquestions}]
          }
          this.data = list.map(quest=>{
            quest.questions=quest.questions.map(item => {
            if (!(item.questiontype == "5" || item.questiontype == "4")) {
              item.statistics = {};
              for(var s in item.questionselect){
                if(!item.questionselect[s].count){
                  item.questionselect[s].count=0
                }
              }
              item.questionselect
              item.statistics.data =  item.questionselect
              var sum = Object.values(item.questionselect).reduce(function(sum, i) {
                return sum + i.count;
              }, 0);
              item.statistics.sum = sum;
              console.log(item.statistics)
            } else {
              item.statistics = false;
            }
            return item;
          }).filter(item=>{
            return item.questiontype != "0"
          });
            return quest
          })
          // 考试标题信息计算
          this.message = res.data.data.setting[0];
          this.message.examtime =
            Math.floor((Number(this.message.examtime) / this.message.total)/ 60) +
            "分" +
            ((Number(this.message.examtime) / this.message.total) % 60).toFixed(0) +
            "秒";
            this.message.rate =Math.round((Number(this.message.pass)/this.message.total)*100)
        }
      });
    },
    showquestlist(data){
      this.dataset = data
      this.show = true
    },
    close(){
       this.show = false
       this.isExport = false
    },
    exported(){
		console.log('点击导出')
		console.log(window.location.origin)
		var  newsrc = window.location.origin + '/api/ExamStatistics/export2?examid='+ this.examid;
		window.open(newsrc, "_blank")
		//'/api/ExamStatistics/export2?examid='+examid
    //   ExamStatistics_export2({examid:this.examid}).then(res=>{
    //       this.isExport=true;
		  // console.log(window.location.origin+ res.data,'--------------------------------')
    //       this.dataUrl =window.location.origin+ res.data;
					
    //   })
    }
  }
};
</script>
<style lang="css" scoped>
.headsmall {
  box-shadow: 0 8px 30px 0 #e8e9ea;
  padding: 10px;
}
.header_title {
  color: #5a5a5a;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
.search {
  height: 60px;
  line-height: 60px;
  text-align: left;
}
.title {
  height: 50px;
  font-size: 24px;
  text-align: center;
  line-height: 50px;
}
.message {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.red {
  color: #ee466e;
  font-weight: bold;
}
.main {
  margin-top: 60px;
}
.issue {
  padding: 30px;
  background: #eee;
  margin-top: 30px;
  border-radius: 10px;
}
.issuetitle {
  font-size: 20px;
  line-height: 30px;
  color: #5a5a5a;
  text-align: left;
  font-weight: bold;
}
.question {
  padding-left: 20px;
  margin-top: 30px;
  text-align: left;
  font-size: 16px;
}
.questiontable {
  background: #fff;
  border-radius: 10px;
  width: 700px;
  margin-top: 10px;
}
.question table {
  width: 700px;
  text-align: center;
  border-collapse: collapse;
}
.questiontitle{
  display: flex;
  justify-content: flex-start;
}
/* .score{
  width: 80px;
} */
.quest{
  width: 900px;
  flex-grow: 1;
  /* border: 1px solid red; */
}
.question table tr {
  height: 50px;
  font-size: 14px;
  border-bottom: 1px solid #dcdde1;
}
.questiondetail {
  margin-top: 20px;
  height: 30px;
  width: 130px;
  line-height: 30px;
  background-color: #eeced4;
  border-radius: 3px;
  color: #ee2761;
  text-align: center;
  font-size: 16px;
}
.routerlink{
	display: block;
}
</style>


// WEBPACK FOOTER //
// src/pages/statistics/anaslyse.vue